package com.downdogapp.client.views.playback

import com.downdogapp.*
import com.downdogapp.AlignItems.CENTER
import com.downdogapp.Color.Companion.NEARLY_OPAQUE_GREY
import com.downdogapp.Display.FLEX
import com.downdogapp.Display.NONE
import com.downdogapp.FlexDirection.ROW
import com.downdogapp.Position.ABSOLUTE
import com.downdogapp.Size.Companion.px
import com.downdogapp.client.AbstractView
import com.downdogapp.client.Strings
import com.downdogapp.client.View
import com.downdogapp.client.controllers.playback.PlaybackUtil
import com.downdogapp.client.controllers.playback.PlaybackViewController
import com.downdogapp.client.widget.RangeSlider
import com.downdogapp.client.widget.RangeSlider.Companion.rangeSlider
import kotlinx.browser.window
import org.w3c.dom.HTMLDivElement
import org.w3c.dom.HTMLElement

class VolumeMenuView(private var anchorElement: HTMLElement,
                     private val controller: PlaybackViewController) : AbstractView() {

  var visible = false; private set

  private val balanceSlider: RangeSlider

  override val root = createDiv {
    position = ABSOLUTE
    display = NONE

    bgColor = NEARLY_OPAQUE_GREY
    borderRadius = px(8)
    padding = px(20)

    centerInParent {
      display = FLEX
      flexDirection = ROW
      alignItems = CENTER

      label(Strings.MUSIC.uppercase(), 12, FontWeight.SEMIBOLD)

      balanceSlider =
        rangeSlider(
          valueRange = 0.0..1.0,
          startValue = PlaybackUtil.audioBalance,
          className = "volume-slider",
          onValueChanged = {
            controller.setAudioBalance(this.proportion, finished = false)
          },
          onMouseUp = {
            controller.setAudioBalance(this.proportion, finished = true)
          },
          block = {
            marginLeft = px(8)
            marginRight = px(8)
            minWidth = px(180)
          }
        )

      label(Strings.VOICE.uppercase(), 12, FontWeight.SEMIBOLD)
    }
  }

  init {
    reposition()
  }

  fun updateAudioBalance() {
    balanceSlider.value = PlaybackUtil.audioBalance
  }

  fun reposition() {
    // Calculate distance of anchor's TOP RIGHT from window's BOTTOM RIGHT
    val boundingBox = anchorElement.getBoundingClientRect()
    val x = window.innerWidth - boundingBox.x - boundingBox.width
    val y = window.innerHeight - boundingBox.y

    root.apply {
      right = px(x)
      bottom = px(y) + px(30)
    }
  }

  override fun fadeIn(duration: Duration, onComplete: View.() -> Unit) {
    super.fadeIn(duration, onComplete)
    visible = true
    reposition()
  }

  override fun fadeOut(duration: Duration, onComplete: View.() -> Unit) {
    super.fadeOut(duration, onComplete)
    visible = false
  }

  override fun show() {
    super.show()
    visible = true
    reposition()
  }

  override fun hide() {
    super.hide()
    visible = false
  }
}

fun HTMLElement.volumeMenuView(anchorElement: HTMLElement,
                               controller: PlaybackViewController,
                               init: HTMLDivElement.() -> Unit = {}): VolumeMenuView {
  val view = VolumeMenuView(anchorElement, controller)
  append(view.root)
  view.root.apply(init)
  return view
}
